import { apiSlice } from '../../../store/apiSlice';
import { Credentials, LoginResponse, RegisterPayload, UserResponse } from '../types';

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, Credentials>({
      query: credentials => ({
        url: '/platform/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    register: builder.mutation<{ message: string }, RegisterPayload>({
      query: userInfo => ({
        url: '/platform/auth/register',
        method: 'POST',
        body: userInfo,
      }),
    }),
    logout: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: '/platform/auth/logout',
        method: 'POST',
      }),
    }),
    profile: builder.query<{ success: boolean; user: UserResponse }, void>({
      query: () => ({
        url: '/platform/auth/profile',
        method: 'GET',
      }),
    }),
    forgotPassword: builder.mutation<{ success: boolean; message: string }, { email: string }>({
      query: body => ({
        url: '/platform/auth/forgot-password',
        method: 'POST',
        body,
      }),
    }),
    resetPassword: builder.mutation<
      { success: boolean; message: string },
      { token: string; newPassword: string }
    >({
      query: body => ({
        url: '/platform/auth/reset-password',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
  useLazyProfileQuery,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = authApiSlice;
